"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetSelectedSimilarProductForSkuUseCase = void 0;
const react_1 = require("react");
const getSelectedSimilarProducts_usecase_1 = require("./getSelectedSimilarProducts.usecase");
/**
 * Caso de uso que obtém as opções de produto similar selecionado pelo CF para determinado SKU.
 */
function useGetSelectedSimilarProductForSkuUseCase() {
    const [sku, setSku] = (0, react_1.useState)(null);
    const [selectedSimilarProducts, callGetSelectedSimilarProductsUseCase] = (0, getSelectedSimilarProducts_usecase_1.useGetSelectedSimilarProductsUseCase)();
    const result = (0, react_1.useMemo)(() => {
        var _a;
        if (sku != null) {
            return (_a = selectedSimilarProducts[sku]) !== null && _a !== void 0 ? _a : null;
        }
        return null;
    }, [selectedSimilarProducts, sku]);
    const call = (0, react_1.useCallback)((sku) => __awaiter(this, void 0, void 0, function* () {
        var _a;
        setSku(sku);
        const selectedProducts = yield callGetSelectedSimilarProductsUseCase([sku]);
        return (_a = selectedProducts[sku]) !== null && _a !== void 0 ? _a : null;
    }), [callGetSelectedSimilarProductsUseCase]);
    return [result, call];
}
exports.useGetSelectedSimilarProductForSkuUseCase = useGetSelectedSimilarProductForSkuUseCase;
